<template>
  <div>
    <el-row :gutter="40" class="panel-group">
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-description">
            <div class="card-panel-text">昨日收入</div>
            <div class="card-panel-num">{{ count.yesterIncome }}</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-description">
            <div class="card-panel-text">七日收入</div>
            <div class="card-panel-num">{{ count.weeklyIncome }}</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-description">
            <div class="card-panel-text">30天收入</div>
            <div class="card-panel-num">{{ count.monthlyIncome }}</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-description">
            <div class="card-panel-text">累积总收入</div>
            <div class="card-panel-num">{{ count.totalIncome }}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- TODO：功能增加时，把这一部分的css提取出来 -->
    <div style="background: #ffffff;">
      <div class="title">收入趋势图</div>
      <div id="income" style="width: 100%;height: 400px;"></div>
    </div>

    <el-dialog v-model="visible" width="450px">
      <div style="color: red;text-align: center;">检测到您还未添加您的企业信息，请尽快填写以免影响后续结算！</div>
      <div style="text-align: center;margin-top: 30px;">
        <el-button @click="visible = false">跳过</el-button>
        <el-button type="primary" @click="toSubject">前往</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts/core'
import { LineChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'
import { GridComponent, TooltipComponent } from 'echarts/components'

import { getChannelDashboard, getMatDashboard, isSubjectInfo } from '@/api/dashboard'

echarts.use(
  [CanvasRenderer, LineChart, TooltipComponent, GridComponent]
)

export default {
  name: 'index.vue',
  data () {
    return {
      count: { yesterIncome: 0, weeklyIncome: 0, monthlyIncome: 0, totalIncome: 0 },
      incomeChartData: {
        xAxis: [],
        yAxis: []
      },
      visible: false
    }
  },
  created () {
    this.getEchartData()
    this.isSubject()
  },
  mounted () {
    this.initIncomeChar()
    window.onresize = () => {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.incomeChart.resize()
      }, 100)
    }
  },
  methods: {
    isSubject () {
      if (localStorage.getItem('accountType') == 1) {
        isSubjectInfo()
        .then(res => {
          if (res.code === 200) {
            this.visible = !res.data
          }
        })
      } 
      
    },
    toSubject () {
      this.$router.push({ path: '/subject/subject' })
    },
    initIncomeChar () {
      var chartDom = document.getElementById('income')
      this.incomeChart = echarts.init(chartDom)
      this.incomeSetOption()
    },
    incomeSetOption () {
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        grid: {
          top: 30,
          bottom: 60,
          left: 60,
          right: 50
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.incomeChartData.xAxis
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: this.incomeChartData.yAxis,
          type: 'line'
        }]
      }
      option && this.incomeChart.setOption(option)
    },
    getEchartData () {
      const accountType = localStorage.getItem('accountType')
      if (accountType === 0) {
        getMatDashboard().then(res => {
          if (res.code === 200) {
            Object.keys(this.count).forEach(key => { this.count[key] = res.data[key] })
            res.data.detail.forEach(item => {
              this.incomeChartData.xAxis.push(item.time)
              this.incomeChartData.yAxis.push(item.income)
            })
            this.incomeSetOption()
          }
        })
      } else {
        getChannelDashboard().then(res => {
          if (res.code === 200) {
            Object.keys(this.count).forEach(key => { this.count[key] = res.data[key] })
            res.data.detail.forEach(item => {
              this.incomeChartData.xAxis.push(item.time)
              this.incomeChartData.yAxis.push(item.income)
            })
            this.incomeSetOption()
          }
        })
      }
    },
    beforeUnmount () {
      window.onresize = null
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;
  .card-panel-col{
    margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      // float: right;
      text-align: center;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
.title{
  margin-bottom: 20px;
  padding-left: 20px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: #262626;
  border-bottom: 1px solid #f0f0f0;
}
</style>
